import { render, staticRenderFns } from "./ProjectModalCreation.vue?vue&type=template&id=52040eea&"
import script from "./ProjectModalCreation.vue?vue&type=script&lang=js&"
export * from "./ProjectModalCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports